import script from "./OperatorNoti.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorNoti.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorNoti.vue?vue&type=style&index=0&id=632f3470&lang=scss"

const __exports__ = script;

export default __exports__